// extracted by mini-css-extract-plugin
export var completionBody = "_e1-2";
export var completionCard = "_e1-0";
export var completionFooter = "_e1-3";
export var completionTitle = "_e1-1";